import { useState, useEffect, useRef, ReactNode, MutableRefObject } from 'react';
import { createPortal } from 'react-dom';

type ReactPortalProps = {
    children: ReactNode;
    wrapperId: string;
}

export const ReactPortal = ({ children, wrapperId }: ReactPortalProps) => {
	const ref: MutableRefObject<HTMLElement | null> = useRef(null);
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		ref.current = document.getElementById(wrapperId);
		setMounted(true);
	}, []);

	return (mounted && ref.current) ? createPortal(children, ref.current) : null;
};